import Token from 'types/models/Token';

let cachedToken: Token | null = null;

export const secureTokenStorage = {
  set(token: Token): void {
    cachedToken = token;
  },

  get(): Token | null {
    return cachedToken;
  },

  clear(): void {
    cachedToken = null;
  },
};
